// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__25KUe","disabled":"FileBtn_disabled__3Qk4r","warn":"FileBtn_warn__lJHBS","fade":"FileBtn_fade__1n5JU"};